module.exports = __webpack_public_path__ + "static/media/cover-unavaliable-green.92a7b4c3.png";